<template>
    <div>
        <div id='divbox'>
            <div id="number">
                {{displayNumber}}
            </div>
            <div id='title'>
                {{title}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'totalNumbers',
  props: ['number', 'title'],
  data () {
    return {
      displayNumber: 0,
      interval: false
    }
  },
  ready () {
    this.displayNumber = this.number ? this.number : 0;
  },
  watch: {
    number () {
      clearInterval(this.interval);

      if (this.number === this.displayNumber) {
        return;
      }

      this.interval = window.setInterval(() => {
        if (this.displayNumber !== this.number) {
          var change = (this.number - this.displayNumber) / 10;
          change = change >= 0 ? Math.ceil(change) : Math.floor(change);
          this.displayNumber = this.displayNumber + change;
        }
      }, 20);
    }
  }
}
</script>
<style scoped>
#divbox {
  /* min-width: 366px; */
  min-height: 177px;
  
  background: rgba(255, 255, 255, 0.5);
  border: 0.8px solid #E5E5E5;
}
#number{
 width: 100%;
 height: 95px;
 margin-top: 10px;

 font-family: WorkSans-ExtraLight;
 font-style: normal;
 font-weight: 200;
 font-size: 96px;
 line-height: 113px;
 text-align: center;
 letter-spacing: -0.02em;

 color: #000000;
}

#title {
 width: 100%;
 height: 21px;
 margin-top:35px;

 font-family: WorkSans-SemiBold;
 font-style: normal;
 font-weight: 600;
 font-size: 18px;
 line-height: 21px;
 text-align: center;
 letter-spacing: -0.02em;

 color: #000000;
}
</style>



// WEBPACK FOOTER //
// TotalNumbers.vue?24342252